import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

const PositioningText = (props) => {
  const { title, text } = props.config

  return (!!title || !!text) && (
    <div className={`positioning-text ${props.hasLeadingItem ? 'with-item' : ''}`}>
      <h1>{title}</h1>
      { title && (
        <span className="separator" style={{ backgroundColor: props.themeColorHex }} />
      )}
      <p>{text}</p>
    </div>
  )
}

PositioningText.propTypes = {
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  hasLeadingItem: PropTypes.bool.isRequired
}

export default PositioningText

